import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import SourceFilesInput from '../SourceFilesInput';

import s from './OnSaleExclusiveForm.scss';

interface Props {
  deviation: PapiDeviation;
}

const OnSaleExclusiveForm: React.FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      <p className={s['hint']}>{t('deviationSubmit.form.onSaleExclusive.hint')}</p>
      <SourceFilesInput deviation={deviation} />
    </div>
  );
};
OnSaleExclusiveForm.displayName = 'OnSaleExclusiveForm';

export default OnSaleExclusiveForm;
